@import '~@splidejs/splide/dist/css/splide.min.css';

/* stylelint-disable selector-class-pattern, max-nesting-depth, selector-max-compound-selectors */
sew-ws-stage {
    background-color: $color-grey-05-light;
    display: block;
    position: relative;

    .swiper-big {
        li {
            list-style: none;
        }

        .splide-pagination {
            all: unset;
            margin: 0;
            bottom: 30px;
            display: flex;
            justify-content: center;
            left: 0;
            position: absolute;
            width: 100%;
            z-index: 1;
            opacity: 0;
            transition: opacity 300ms;
            column-gap: 10px;

            li {
                line-height: 10px !important;
                width: 10px;
                height: 10px;
                overflow: hidden;
            }
        }

        .splide-pagination-item {
            all: unset;
            background-color: $color-grey-04-middle;
            cursor: pointer;
            height: 40px;
            margin: 0;
            width: 40px;

            &.is-active {
                background-color: $color-red;
            }
        }

        &.swiper-minimize,
        &.video-plays,
        &.show-pager {
            .splide-pagination {
                z-index: 2;
                opacity: 1;
            }
        }

        &.no-consent,
        &.video-plays {
            .stage-teaser {
                display: none;
            }

            sew-video {
                z-index: 2;
            }
        }
    }

    .swiper-small-container {
        bottom: 0;
        position: absolute;
        width: 100%;
        z-index: 1;

        .grid {
            @include grid;
        }

        .swiper-scale-container {
            grid-area: 1 / 2 / 2 / 14;
            background-color: $color-grey-01-dark;
            display: flex;
            opacity: 1;
            transform: scaleY(1);
            transform-origin: bottom;
            transition:
                transform 300ms,
                opacity 150ms;
            width: 100%;

            @include mq-1 {
                grid-area: 1/1/2/15;
            }

            &.video-plays,
            &.swiper-minimize {
                opacity: 0;
                transform: scaleY(0);
                transition:
                    transform 300ms,
                    opacity 150ms 150ms;
            }

            &.is-moving {
                .splide__slide.is-next {
                    &::before {
                        opacity: 0;
                    }
                }
            }
        }

        .splide {
            width: calc(100% - 70px);
        }

        .topic-line {
            @include typo-ws-paragraph-s;

            color: $color-white;
            text-transform: uppercase;
        }

        .headline {
            @include typo-ws-h4;

            font-size: clamp(18px, 1.388vw, 20px);
            line-height: clamp(26px, 1.944vw, 28px);
            min-height: 56px;
            color: $color-white;
        }

        .splide__slide {
            box-sizing: border-box;
            padding: 24px 32px;
            position: relative;
            cursor: pointer;

            &::before {
                background-color: $color-grey-03;
                bottom: 20px;
                content: '';
                left: 0.5px;
                position: absolute;
                top: 20px;
                width: 1px;
                z-index: 1;
                opacity: 1;
                transition: opacity 1s;
            }

            &:hover {
                .topic-line,
                .headline {
                    color: $color-white;
                }
            }
        }

        .splide__slide.is-active {
            &::before {
                display: none;
            }
        }

        a {
            display: none;
        }

        .swiper-button-prev,
        .swiper-button-next {
            align-items: center;
            color: $color-grey-03;
            display: flex;
            flex-shrink: 0;
            position: relative;
            width: 35px;
            z-index: 1;
            cursor: pointer;
            background-color: $color-grey-01-dark;

            .svg {
                margin: 0 -16px;
                width: 48px;
            }

            &:hover {
                color: $color-white;
            }

            &::before {
                content: '';
                position: absolute;
                top: 0;
                height: 100%;
                background-color: inherit;
                width: 3px;
            }
        }

        .swiper-button-prev {
            justify-content: flex-end;

            &::before {
                right: -3px;
            }
        }

        .swiper-button-next {
            justify-content: flex-start;

            &::before {
                left: -3px;
            }
        }
    }

    .section-bridge {
        background-color: $color-grey-05-light;
        height: var(--half-of-small-slider);
        transition: height 300ms;

        &.bridge-minimize {
            height: 0;
        }
    }

    &.no-progress-bar {
        sew-ws-stage-item {
            .stage-teaser::after {
                display: none;
            }
        }
    }
}

@include mq-2-min {
    sew-ws-stage {
        &[compact] {
            .image-wrapper,
            .video-wrapper {
                max-height: 400px;
                min-height: auto;
            }

            .stage-teaser {
                top: auto;
                transform: none;

                @include mq-4-min {
                    // half max content width, see _grid.scss
                    transform: translate3d(-880px, 0, 0);
                }
            }
        }
    }
}

@include mq-1 {
    sew-ws-stage {
        .swiper-big {
            .splide-pagination {
                bottom: 12px;
            }

            &.video-plays {
                .splide-pagination {
                    z-index: 1;
                }

                .stage-teaser {
                    display: block;
                }
            }
        }

        &.no-progress-bar {
            sew-ws-stage-item {
                padding-bottom: 0;

                .stage-teaser {
                    position: relative;
                    bottom: 40px;
                }
            }
        }

        .swiper-small-container {
            .swiper-scale-container {
                &.video-plays:not(.swiper-minimize) {
                    opacity: 1;
                    transform: scaleY(1);
                }
            }
        }

        &[compact] {
            @include grid;

            background-color: transparent;
            margin-top: 60px;

            .mobile-headline {
                grid-column: 2 / -2;
                .headline {
                    @include typo-ws-h1;

                    margin: 0;
                }
            }

            .stage {
                display: none;
            }
        }
    }
}
